import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const getRowStyles = (isClickable) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "320px",
  py: 1,
  ...(isClickable && {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  }),
});

const styles = {
  label: {
    flex: 1,
    fontSize: "16px",
    color: "text.primary",
  },
  value: {
    fontSize: "16px",
    fontWeight: 500,
    color: "text.primary",
    minWidth: "80px",
    textAlign: "right",
  },
};

export default function ChargesRow({
  value,
  label,
  operator = "plus",
  onInfoClick,
  showInfoButton = true,
}) {
  const formatCurrency = amount => {
    const num = typeof amount === "number" ? amount : parseFloat(amount) || 0;
    return `$${num.toFixed(2)}`;
  };



  return (
    <Box 
      sx={getRowStyles(showInfoButton)} 
      onClick={showInfoButton ? onInfoClick : undefined}
    >
      <Typography sx={styles.label}>
        {label}
      </Typography>
      <Typography sx={styles.value}>
        {formatCurrency(value)}
      </Typography>
    </Box>
  );
}
